import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Header,
  Modal,
  Table,
  Label,
} from 'semantic-ui-react';
import { withTranslation } from 'react-i18next';

import LawyerItem from '../../components/LawyerItem';
import ProjectPanelLawyers from '../../components/ProjectPanelLawyers';
import { namespaces, TRANSLATION_FILES } from '../../constants/translation';

import InviteLawyerForm from './InviteLawyerForm';

class PanelLawyersList extends Component {
  static contextTypes = {
    store: PropTypes.object,
  }
  static propTypes = {
    open: PropTypes.bool,
    onClose: PropTypes.func,
    onConfirm: PropTypes.func,
    onSelect: PropTypes.func,
    onCheck: PropTypes.func,
    selected: PropTypes.arrayOf(PropTypes.object),
    loanTrackerProjectID: PropTypes.number,
    projectName: PropTypes.string,
    loading: PropTypes.bool,
    setLoading: PropTypes.func,
    extraNode: PropTypes.func,
    company: PropTypes.oneOfType([
      PropTypes.object,
    ]),
  }
  static defaultProps = {
    loanTrackerProjectID: 0,
  }
  static getPropsToState = (props) => {
    const oriSelected = props.selected ? [].concat(props.selected) : [];
    return {
      oriSelected,
      company: props.company,
    };
  }
  constructor(props) {
    super(props);
    const state = PanelLawyersList.getPropsToState(props);
    this.state = {
      ...state,
      selected: null,
      showInviteLawyer: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    const state = PanelLawyersList.getPropsToState(nextProps);
    this.setState(state);
  }
  handleOnConfirm = (e) => {
    e.preventDefault();
    if (this.props.onConfirm) {
      this.props.onConfirm(e, this.state.selected);
    }
    this.setState({ selected: null });
  }
  handleOnClose = (e) => {
    if (this.props.onClose) {
      this.props.onClose(e);
    }
  }
  handleOnSelect = (e, lawyer) => {
    const selected = this.state.selected === lawyer ? null : lawyer;
    this.setState({ selected }, () => {
      if (this.props.onSelect) {
        this.props.onSelect(selected);
      }
    });
  }
  handleOnCheck = (lawyer) => {
    if (this.props.onCheck) {
      const { selected } = this.state;
      return this.props.onCheck(lawyer, selected);
    }
    return false;
  }
  handleShowInviteLawyer = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showInviteLawyer: true,
    });
  }
  handleCloseInviteLawyer = (e) => {
    if (e) { e.preventDefault(); }
    this.setState({
      showInviteLawyer: false,
    }, () => {
      if (this.inviteForm) {
        this.inviteForm.resetData();
      }
    });
  }
  render() {
    const { t } = this.props;
    return (
      <Modal
        open={this.props.open === true}
        onClose={this.handleOnClose}
        closeIcon="close"
        size="large"
        className="items-list-modal PanelLawyers"
      >
        <Header
          icon="add user"
          content={t('Assign lawyer')}
        />
        <Modal.Content>
          <InviteLawyerForm
            company={this.props.company}
            ref={(ref) => { this.inviteForm = ref; }}
            open={this.state.showInviteLawyer}
            onClose={this.handleCloseInviteLawyer}
            onConfirm={this.handleCloseInviteLawyer}
            loanTrackerProjectID={this.props.loanTrackerProjectID}
            projectName={this.props.projectName}
            loading={this.props.loading}
            setLoading={this.props.setLoading}
          />
          <ProjectPanelLawyers
            loanTrackerProjectID={this.props.loanTrackerProjectID}
            rowNode={(sub, idx, currentTab) => {
              const isSelected = (this.state.selected && this.state.selected.lawyer_id === sub.lawyer_id);
              // const isExist = this.state.oriSelected.some(s => s.lawyer_id === sub.lawyer_id);
              return (
                <Table.Row
                  key={idx}
                  positive={isSelected}
                  active={this.handleOnCheck(sub)}
                >
                  <Table.Cell>
                    <LawyerItem
                      item={sub}
                      headerNode={currentTab === 'invited' ? (
                        <Label>{t('Pending Registration')}</Label>
                      ) : null}
                      onClick={this.handleOnSelect}
                      selected={isSelected}
                      disabled={this.handleOnCheck(sub) || currentTab === 'invited'}
                      checkable={currentTab === 'panel'}
                    />
                  </Table.Cell>
                </Table.Row>
              );
            }}
            extraNode={this.props.extraNode ? this.props.extraNode(this.state.selected) : null}
          />
        </Modal.Content>
        <Modal.Actions style={{ justifyContent: 'center' }}>
          <Button
            primary
            onClick={this.handleOnConfirm}
            icon="checkmark"
            content={t('Confirm', { ns: TRANSLATION_FILES.translation })}
            disabled={!this.state.selected}
          />
        </Modal.Actions>
      </Modal>
    );
  }
}

export default withTranslation(namespaces)(PanelLawyersList);



// WEBPACK FOOTER //
// ./src/containers/modals/PanelLawyersList.jsx